export enum ErrorMessage {
    ENGINEER = 'Something went wrong with this request. Please try again later or give us a call on <a href="tel:0330 0589485">0330 0589485</a>.',
    CUSTOMER = 'Something went wrong with this request. Please try again later or give us a call on <a href="tel:0330 912 4843">0330 912 4843</a>.',
}
